<ng-container *ngIf="tenantError">
  <div class="d-flex justify-content-center align-items-center h-100vh">
    <!-- {{tenantError}} -->

    <div class="card shadow w-75 w-lg-25">
      <div class="card-header d-flex flex-column align-items-center justify-content-center my-4">
        <img width="200px" style="margin-bottom: 10px;" src="assets/images/logos/logo-2.svg">
        <p>SaaS App</p>
      </div>
      <div class="card-body d-flex flex-column justify-content-center ">
        <h3 class=" fs-2 text-center">Direct access is not allowed</h3>
        <p class="card-text text-center">You need to have a partner account with SanchiConnect to get access to the
          panel.</p>
      </div>
    </div>

  </div>

</ng-container>

<ng-container *ngIf="maintainanceMode">
  <app-maintenance-page></app-maintenance-page>
</ng-container>


<ng-container *ngIf="!subscriptionActive">
  <div class="d-flex justify-content-center align-items-center h-100vh">

    <div class="card shadow w-75 w-lg-25">
      <div class="card-header d-flex flex-column align-items-center justify-content-center my-4">
        <img width="200px" style="margin-bottom: 10px;" src="assets/images/logos/logo-2.svg">
        <p>SaaS App</p>
      </div>
      <div class="card-body d-flex flex-column justify-content-center ">
        <h3 class=" fs-2 text-center">Subscription expired</h3>
        <p class="card-text text-center">{{brandDetails.subscription_active_message}}</p>
      </div>
    </div>

  </div>

</ng-container>

<div *ngIf="brandDetails?.maintenance_mode?.active && maintenanceClosed && !maintainanceMode"
  class="position-absolute top-0 start-0 w-100 maintainance-notice py-5">
  <div></div>
  <div>
    <b>
    {{brandDetails.maintenance_mode.title}}:
    </b>
    {{brandDetails.maintenance_mode.message}}

    <br />
    <span class="svg-icon svg-icon-4 me-1">
      <i class="bi bi-clock" ngbTooltip="Deadline"></i>
    </span>
    {{formatMaintenanceTime(brandDetails.maintenance_mode.startTime)}} - {{formatMaintenanceTime(brandDetails.maintenance_mode.endTime)}}

  </div>
  <div class="me-4  text-white cursor-pointer" (click)="handleCloseNotice()">
    <i class="bi bi-x fs-2hx"></i>
  </div>
</div>

<ng-container *ngIf="!tenantLoading && !tenantError && !maintainanceMode && subscriptionActive">
  <router-outlet></router-outlet>
</ng-container>

<!-- PWA Install Prompt -->
<div *ngIf="showInstallPrompt" class="pwa-install-banner">
  <button class="pwa-close-btn" (click)="dismissInstallPrompt()">
    <i class="bi bi-x-lg"></i>
  </button>
  <div class="pwa-install-content">
    <div class="pwa-install-icon">
      <img *ngIf="globalSettings?.imgKitUrl && globalSettings?.branding?.favicon"
           [src]="globalSettings.imgKitUrl + globalSettings.branding.favicon + '?tr=w-40,h-40,cm-pad_resize'"
           alt="App Icon" class="pwa-app-logo">
      <i *ngIf="!globalSettings?.branding?.favicon" class="bi bi-download"></i>
    </div>
    <div class="pwa-install-text" *ngIf="!isIos">
      <strong>Install App</strong>
      <span>Get quick access from your home screen</span>
    </div>
    <div class="pwa-install-text" *ngIf="isIos">
      <strong>Install App</strong>
      <span>Tap <i class="bi bi-box-arrow-up"></i> then "Add to Home Screen"</span>
    </div>
    <div class="pwa-install-actions" *ngIf="!isIos">
      <button class="btn btn-sm btn-primary" (click)="installApp()">Install</button>
    </div>
  </div>
</div>

<!-- New version available (SAN-1140) -->
<div *ngIf="showUpdatePrompt" class="pwa-install-banner">
  <button class="pwa-close-btn" (click)="dismissUpdatePrompt()">
    <i class="bi bi-x-lg"></i>
  </button>
  <div class="pwa-install-content">
    <div class="pwa-install-icon">
      <i class="bi bi-arrow-clockwise"></i>
    </div>
    <div class="pwa-install-text">
      <strong>Update Available</strong>
      <span>Refresh to get the latest version</span>
    </div>
    <div class="pwa-install-actions">
      <button class="btn btn-sm btn-primary" (click)="reloadForUpdate()">Refresh</button>
    </div>
  </div>
</div>
